import {connect} from "react-redux";
import UsTaxesPage from "./UsTaxesPage";
import * as InventoryApiActions from "../../actions/InventoryApiActions";
import * as ViewActions from "../../actions/ViewActions";

export default connect(null, {...InventoryApiActions, ...ViewActions})(UsTaxesPage);